module.exports = __webpack_public_path__ + "static/media/hog@2x.0f168397.jpg";